import { render, staticRenderFns } from "./PipelineTrendChart.vue?vue&type=template&id=54b08b02&scoped=true&"
import script from "./PipelineTrendChart.vue?vue&type=script&lang=js&"
export * from "./PipelineTrendChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b08b02",
  null
  
)

export default component.exports